import { render, staticRenderFns } from "./BlackBeltSVG.vue?vue&type=template&id=05a82caf"
import script from "./BlackBeltSVG.vue?vue&type=script&lang=js"
export * from "./BlackBeltSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports